import { Chart } from "react-charts";
import React from "react";
import { ResizableBox as ReactResizableBox } from "react-resizable";

export default function MicroF1() {
    const data = React.useMemo(
        () => [
          {
            label: "Micro F1 Training",
            data: [
              { primary: "Boost", secondary: 0.7613454138862692},
              { primary: "Decision Tree", secondary: 0.7615072085444035},
              { primary: "NB", secondary: 0.7622182167557309},
              { primary: "SGD", secondary: 0.76239270002148},
              { primary: "SVM", secondary: 0.7618531520080329},
            ],
          }, {
            label: "Micro F1 Testing",
            data: [
              { primary: "Boost", secondary: 0.7459430191263358},
              { primary: "Decision Tree", secondary: 0.7474114182578132},
              { primary: "NB", secondary: 0.7493644337104362},
              { primary: "SGD", secondary: 0.7485831963091267},
              { primary: "SVM", secondary: 0.750059505863311},
            ],
          }, 
        ],
        []
      );
      const axes = React.useMemo(
        () => [
          { primary: true, type: 'ordinal', position: 'bottom' },
          { type: 'linear', position: 'left' },
        ], []
      );
      return (
          <ReactResizableBox width={500} height={300} style={{textAlign: "center"}}>
              <strong>Micro F1</strong>
              <Chart data={data} axes={axes} tooltip/>
          </ReactResizableBox>
      );
};